import React from 'react';
import '../assets/styles/css/main.css';

const Footer = () => {
    return (
        <div className="footer">
            <p>© Ken Javier 2021</p>
        </div>
    )
}

export default Footer
